module.exports = " <div class=vc-modal v-show=show transition=vc-modal-scale> <div class=vc-modal-header v-if=title> <div class=vc-modal-title> {{title}} </div> </div> <div class=vc-modal-body> <slot> <div v-if=msg> {{msg}} </div> </slot> </div> <div class=vc-modal-footer v-if=!hideClose> <slot name=footer> <button text=关闭 @click=close></button> </slot> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modal/modal.vue
 ** module id = 465
 ** module chunks = 1
 **/